import { Flex } from 'foundations-components/components/Flex';
import { BackButton as BaseBackButton } from 'foundations-components/transitional/components/BackButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const Footer = props => {
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-default",
    paddingBlockStart: "500",
    justifyContent: "end",
    alignItems: "start"
  }, props));
};
export const BackButton = props => {
  return /*#__PURE__*/_jsx(BaseBackButton, {
    marginInlineEnd: "auto",
    flexShrink: 0,
    paddingInlineEnd: "400",
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      use: "transparent"
    }, props))
  });
};